import type { DeckardIcon, DeckardIconProps } from '@assets/icons';
import { Group } from '@components/layout';
import { Typography } from '@components/typography';
import { sideNavExpandedAtom } from '@hooks/sideNavAtoms';
import { useTheme, type SxProps } from '@mui/material';
import { useAtom } from 'jotai';

export const SideNavButton = ({
  Icon,
  iconProps,
  label,
  onClick,
  selected = false,
  sx,
}: {
  Icon: DeckardIcon;
  iconProps?: DeckardIconProps;
  label: string;
  onClick: () => void;
  selected?: boolean;
  sx?: SxProps;
}) => {
  const { palette } = useTheme();
  const [isExpanded] = useAtom(sideNavExpandedAtom);
  return (
    <Group
      alignItems="center"
      justifyContent="flex-start"
      height="44px"
      width="100%"
      overflow="hidden"
      sx={{
        my: 1,
        borderTopLeftRadius: 4,
        borderBottomLeftRadius: 4,
        cursor: selected ? 'default' : 'pointer',
        backgroundColor: selected ? 'background.default' : 'transparent',

        color: selected ? palette.text.accent : palette.grey[300],
        '&:hover': {
          backgroundColor: selected ? 'background.default' : 'grey.700',
          color: selected ? palette.text.accent : palette.grey[200],
        },
        ...sx,
      }}
      onClick={onClick}
      role="button"
    >
      <Group minWidth="52px" alignItems="center" justifyContent="center">
        <Icon size={24} color={selected ? palette.text.accent : palette.grey[300]} {...iconProps} />
      </Group>
      {isExpanded && (
        <Typography
          variant="body2"
          sx={{ whiteSpace: 'nowrap', fontWeight: selected ? 'bold' : 'normal' }}
        >
          {label}
        </Typography>
      )}
    </Group>
  );
};
